import { useSignal } from "@preact/signals-react";
import { setupLocalState } from "../../library/dataService";

import { DropkiqUIFromScope } from "./DropkiqUIFromScope";
import "./dropkiq.css";

import { Buffer } from "buffer";
import { useEffect } from "react";
import { INGContextAutocomplete } from "../../library/NGFieldExtensions";
import { getTestId } from "../../library/utils";
import type { DropkiqUI } from "./DropkiqUI";
import { isArray } from "lodash-es";

window.Buffer = Buffer;

const DROPKIQ_LICENSE_KEY = import.meta.env.VITE_DROPKIQ_LICENSE_KEY;

export function NGContextAutocomplete({ config, context }: INGContextAutocomplete) {
  const local = setupLocalState(
    config,
    {
      Disabled: useSignal(config.Disabled ?? false),
      Model: useSignal(config.Model ?? {}),
    },
    context
  );
  const l = context.Path.length;

  const { Element, setDropkiqUI } = context.Path[l - 2];

  const dropkiqUiRef = useSignal<DropkiqUI | null>(null);

  useEffect(() => {
    const setupDropkiq = async () => {
      if (local.Disabled.value && dropkiqUiRef.value && (!local.Model.value || isArray(local.Model.value))) {
        dropkiqUiRef.value.disable();
        return;
      }

      if (dropkiqUiRef.value && !dropkiqUiRef.value.isEnabled && !local.Disabled.value) {
        dropkiqUiRef.value.enable();
      } else {
        const dropkiqFromScope = await DropkiqUIFromScope.init(
          Element,
          local.Model.value || {},
          DROPKIQ_LICENSE_KEY,
          {}
        );

        dropkiqUiRef.value = await dropkiqFromScope.dropkiqUI();
      }

      setDropkiqUI && setDropkiqUI(dropkiqUiRef.value);
    };

    setupDropkiq();
  }, [Element, dropkiqUiRef, local.Disabled.value, local.Model.value, setDropkiqUI]);

  return <div id={config.Id} data-testid={getTestId(config)} data-type={config.__typename} />;
}
